export default __webpack_public_path__ + "397498d9f100f8c1843d57ae6a42969c.png";